module.exports = __webpack_public_path__ + "static/assets/8a08e217b9a1853e05ba2dbda06c92cc.jpg";